import configStore from "../../stores/ConfigStore";

import handler from "../health/responseHandler";
import { Token } from "./Token";

export default class TokenDataService {

    /**
     * Get the user token for a given resource.
     *
     * @static
     * @param {string} meetCode
     * @returns {Promise<Token>}
     * @memberof TokenDataService
     */
    public static getSessionTokenAsync = async (meetCode: string): Promise<Token> => {

        return fetch(`${configStore.hosts.api}/token/session/${meetCode}`, {
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(t => handler.onJson(t))
        .catch(e => handler.onError(e))
    }

    /**
     * Refresh the user token for a given resource.
     *
     * @static
     * @returns {Promise<Token>}
     * @memberof TokenDataService
     */
    public static refreshTokenAsync(): Promise<{
        access_token: string,
        expires_at: number
    }> {
        
        return fetch(`${configStore.hosts.api}/token/refresh`, {
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(t => handler.onJson(t))
        .catch(e => handler.onError(e))
    }
}
